import Phaser from 'phaser';

export class Toast {
  static show(scene: Phaser.Scene, message: string, duration: number = 3000) {
    const width = scene.cameras.main.width;
    const height = scene.cameras.main.height;

    const container = scene.add.container(width / 2, height + 50);

    const bg = scene.add.graphics();
    bg.fillStyle(0x000000, 0.8);
    bg.lineStyle(2, 0xd4af37, 1);
    bg.fillRoundedRect(-150, -25, 300, 50, 10);
    bg.strokeRoundedRect(-150, -25, 300, 50, 10);

    const txt = scene.add.text(0, 0, message, {
        fontSize: '16px',
        color: '#ffffff'
    }).setOrigin(0.5);

    container.add([bg, txt]);
    container.setDepth(1000);

    scene.tweens.add({
        targets: container,
        y: height - 100,
        duration: 300,
        ease: 'Back.out',
        onComplete: () => {
            scene.time.delayedCall(duration, () => {
                scene.tweens.add({
                    targets: container,
                    y: height + 50,
                    duration: 300,
                    ease: 'Back.in',
                    onComplete: () => container.destroy()
                });
            });
        }
    });
  }
}
